import { SaveButtonBaseProps, SaveButtonProps } from '../SaveButtonProps';
import { SavedPageVariantProps } from './SavedPageVariant';
import { ComponentVariantProps } from './ComponentVariant';

export const CLICK_DELAY_ON_MOBILE = 1500;
export const CLICK_DELAY_ON_DESKTOP = 800;
// If the user is not logged in, they will be redirected.
// The clicked state of the button is shown until the redirection succeeds.
export const CLICK_DELAY_SIGNED_OUT = 5000;

export const getPropsForSignedInMobile = (
	props: SaveButtonProps
): ComponentVariantProps => {
	const propsForSignedInMobile = mapProps(props) as ComponentVariantProps;
	propsForSignedInMobile.isSaved = props.isSaved;
	propsForSignedInMobile.clickDelay = CLICK_DELAY_ON_MOBILE;
	propsForSignedInMobile.savedDefaultIsVisible = true;
	propsForSignedInMobile.unsavedDefaultIsVisible = true;
	return propsForSignedInMobile;
};

export const getPropsForSignedInDesktop = (
	props: SaveButtonProps
): ComponentVariantProps => {
	const propsForSignedInDesktop = mapProps(props) as ComponentVariantProps;
	propsForSignedInDesktop.isSaved = props.isSaved;
	propsForSignedInDesktop.clickDelay = CLICK_DELAY_ON_DESKTOP;
	propsForSignedInDesktop.savedDefaultIsVisible = true;
	propsForSignedInDesktop.unsavedDefaultIsVisible =
		props.saveConfig.alwaysVisible;
	propsForSignedInDesktop.tooltip.saved = '';
	propsForSignedInDesktop.tooltip.unsaved = '';
	return propsForSignedInDesktop;
};

export const getPropsForSignedOutMobile = (
	props: SaveButtonProps
): ComponentVariantProps => {
	const propsForSignedOutMobile = mapProps(props) as ComponentVariantProps;
	propsForSignedOutMobile.clickDelay = CLICK_DELAY_SIGNED_OUT;
	propsForSignedOutMobile.isSaved = props.isSaved;
	propsForSignedOutMobile.unsavedDefaultIsVisible = true;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	propsForSignedOutMobile.tooltip.save =
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		props.saveConfig.translationMap.tooltip.redirectToLoginAndSave;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	propsForSignedOutMobile.tooltip.saved =
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		props.saveConfig.translationMap.tooltip.redirectedToLoginAndSave;
	propsForSignedOutMobile.tooltip.unsave = '';
	propsForSignedOutMobile.tooltip.unsaved = '';
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	propsForSignedOutMobile.saveAriaLabel =
		props.saveConfig?.translationMap.redirectToLoginAndSaveAriaLabel;
	return propsForSignedOutMobile;
};

export const getPropsForSignedOutDesktop = (
	props: SaveButtonProps
): ComponentVariantProps => {
	const propsForSignedOutDesktop = mapProps(props) as ComponentVariantProps;
	propsForSignedOutDesktop.clickDelay = CLICK_DELAY_SIGNED_OUT;
	propsForSignedOutDesktop.isSaved = props.isSaved;
	propsForSignedOutDesktop.unsavedDefaultIsVisible =
		props.saveConfig.alwaysVisible;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	propsForSignedOutDesktop.tooltip.save =
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		props.saveConfig.translationMap.tooltip.redirectToLoginAndSave;
	propsForSignedOutDesktop.tooltip.saved = '';
	propsForSignedOutDesktop.tooltip.unsave = '';
	propsForSignedOutDesktop.tooltip.unsaved = '';
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	propsForSignedOutDesktop.saveAriaLabel =
		props.saveConfig?.translationMap.redirectToLoginAndSaveAriaLabel;
	return propsForSignedOutDesktop;
};

export const getPropsForSavedPageInMobile = (
	props: SaveButtonProps
): SavedPageVariantProps => {
	const propsForSavedPageInMobile = mapProps(props) as SaveButtonBaseProps;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	propsForSavedPageInMobile.buttonState = props.buttonState;
	propsForSavedPageInMobile.savedDefaultIsVisible = true;
	propsForSavedPageInMobile.unsavedDefaultIsVisible = true;
	return propsForSavedPageInMobile;
};

export const getPropsForSavedPageInDesktop = (
	props: SaveButtonProps
): SavedPageVariantProps => {
	const propsForSavedPageInDesktop = mapProps(props) as SaveButtonBaseProps;
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	propsForSavedPageInDesktop.buttonState = props.buttonState;
	propsForSavedPageInDesktop.savedDefaultIsVisible =
		props.saveConfig.alwaysVisible;
	propsForSavedPageInDesktop.unsavedDefaultIsVisible = true;
	propsForSavedPageInDesktop.tooltip.saved = '';
	propsForSavedPageInDesktop.tooltip.unsaved = '';
	return propsForSavedPageInDesktop;
};

const mapProps = (props: SaveButtonProps) => {
	return {
		className: props.className,
		item: props.item,
		tooltipDisabled: props.saveConfig.tooltipDisabled,
		saveAriaLabel: props.saveConfig?.translationMap.saveAriaLabel,
		unsaveAriaLabel: props.saveConfig?.translationMap.unsaveAriaLabel,
		tooltip: {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			save: props.saveConfig.translationMap.tooltip.save,
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			unsave: props.saveConfig.translationMap.tooltip.unsave,
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			saved: props.saveConfig.translationMap.tooltip.saved,
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			unsaved: props.saveConfig.translationMap.tooltip.unsaved,
		},
		parentIsHovered: props.parentIsHovered,
		parentIsFocusVisible: props.parentIsFocusVisible,
		onClick: props.onClick,
		brand: props.brand,
	};
};
